import * as React from "react";
import { useParameter } from "../../../shared";

export function useSlideTitle() {
  const [business] = useParameter<number>("@business-units");
  const bname = (business || 1) === 2 ? "APE" : "AP";

  const title = `${bname} major crops by lead countries - annual area development (in %)`;

  return title;
}
